import React from 'react';
import { PostsList } from '../PostsList';
import { Post } from '../Post';
import { PostFormTypes, PostReply } from '../Post.types';
import { SonForm } from '../../../Form2';

type PostReplies = {
  replies?: PostReply[];
  parentPostNumber: number;
  previousPostId?: string;
  currentForm: SonForm<PostFormTypes> | undefined;
  setCurrentForm: (newState: SonForm<PostFormTypes> | undefined) => void;
};

export function PostReplies(
  { replies, parentPostNumber, previousPostId, currentForm, setCurrentForm }: PostReplies,
) {
  if (!replies || replies.length === 0) {
    return null;
  }

  /**
   * Creating counter for replies like this:
   * "Reply 1.3"
   */
  const getPostNumberForReply = (index: number): string => `${parentPostNumber}.${index + 1}`;

  return (
    <div className="posts__replies">
      <PostsList headingHierarchy={4} type="reply">
        {replies.map((reply, index) => {
          return (
            <Post
              type="reply"
              post={reply}
              postNumber={getPostNumberForReply(index)}
              headingHierarchy={5}
              previousPostId={previousPostId}
              key={reply.id}
              currentForm={currentForm}
              setCurrentForm={setCurrentForm}
            />
          );
        })}
      </PostsList>
    </div>
  );
}
